import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import useNoIndex from "@/lib/useNoIndex";

export default function Processing() {
  useNoIndex();
  const [params] = useSearchParams();
  const result_id = params.get("result_id");
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      if (result_id) {
        navigate(`/results/${result_id}`, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }, 1800);
    return () => clearTimeout(t);
  }, [result_id, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 bg-connexus-accent text-center fade-up"
      data-testid="processing-screen"
    >
      <Loader2 className="w-10 h-10 text-connexus animate-spin" />
      <h1 className="mt-5 text-xl sm:text-2xl font-semibold text-connexus">
        Analyzing your relationship patterns…
      </h1>
      <p className="mt-2 text-sm text-connexus-textSecondary max-w-md">
        Finding what your bond needs most right now.
      </p>
    </div>
  );
}
